import type { ElementDisponibleType } from '@/types';

export const RELANCE_ELEMENTS_DISPONIBLES: ElementDisponibleType[] = [
  {
    libelle: 'Date du jour',
    valeur: '{Date_du_jour}',
    icon: 'Calendar',
  },
  {
    libelle: 'Date limite de régie prolongée',
    valeur: '{Date_regie_prolongee}',
    icon: 'Clock',
  },
  {
    libelle: 'Montant total des impayés',
    valeur: '{Montant_total}',
    icon: 'Euro',
  },
  {
    libelle: 'Tableau des factures impayées',
    valeur: '{Tableau_factures}',
    icon: 'Table',
  },
];

// Éléments disponibles pour la relance « avant date limite de paiement ».
// Variante de RELANCE_ELEMENTS_DISPONIBLES : avant l'échéance, les sommes sont « dues », pas « impayées ».
export const RELANCE_AVANT_ECHEANCE_ELEMENTS_DISPONIBLES: ElementDisponibleType[] = [
  {
    libelle: 'Date du jour',
    valeur: '{Date_du_jour}',
    icon: 'Calendar',
  },
  {
    libelle: 'Date limite de paiement',
    valeur: '{Date_limite_paiement}',
    icon: 'Clock',
  },
  {
    libelle: 'Montant total dû',
    valeur: '{Montant_total}',
    icon: 'Euro',
  },
  {
    libelle: 'Tableau des factures dues',
    valeur: '{Tableau_factures}',
    icon: 'Table',
  },
];
